import React, { useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import { ContentProvider } from './context/ContentContext';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import ScrollProgress from './components/ScrollProgress';
import Preloader from './components/Preloader';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import BlogsPage from './pages/BlogsPage';
import BlogPost from './pages/BlogPost';
import ServicesPage from './pages/ServicesPage';
import GalleryPage from './pages/GalleryPage';
import AwardsPage from './pages/AwardsPage';
import TestimonialsPage from './pages/TestimonialsPage';
import BooksPage from './pages/BooksPage';
import SelfTalkPage from './pages/SelfTalkPage';
import EventsPage from './pages/EventsPage';
import EventDetail from './pages/EventDetail';

function AppContent() {
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  return (
    <>
      {loading && <Preloader onComplete={() => setLoading(false)} />}
      <div className="App">
        <ScrollProgress />
        <Header />
        <main key={location.pathname} className="page-transition">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/blogs" element={<BlogsPage />} />
            <Route path="/tag/:tag" element={<BlogsPage />} />
            <Route path="/blog/:id" element={<BlogPost />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/awards" element={<AwardsPage />} />
            <Route path="/testimonials" element={<TestimonialsPage />} />
            <Route path="/books" element={<BooksPage />} />
            <Route path="/self-talk" element={<SelfTalkPage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/events/:slug" element={<EventDetail />} />
          </Routes>
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}

function App() {
  return (
    <ContentProvider>
      <AppContent />
    </ContentProvider>
  );
}

export default App;
